import React from 'react';
import { PartnerInvoiceDto } from '../../store/partnerInvoiceSlice';
import useTranslate from '../useTranslate';
import { Link } from 'react-router';
import { API_SHORT } from '../../constants';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

interface Props {
    year: number;
    invoices: PartnerInvoiceDto[];
}

function PartnerInvoicesGroup({ year, invoices }: Readonly<Props>) {
    const strings = useTranslate('PartnerInvoices');
    const [active, setActive] = React.useState(true);
    const sortedInvoices = React.useMemo(
        () => sortInvoicesIntoGroups(invoices),
        [invoices]
    );

    return (
        <ul key={year} className={'year-wrapper'}>
            <li className={active ? 'year active' : 'year'}>
                <Button
                    bsStyle={'link'}
                    className={'title text-decoration-none'}
                    onClick={() => setActive(!active)}
                    aria-expanded={active}
                >
                    <i className="icon icon-wew-arrow-right icon-sm active-indicator" />
                    <span>{year}</span>
                </Button>
                <ul className={'month-wrapper'}>
                    <div className={'col'}>
                        {sortedInvoices.map((invoice) => renderLink(invoice))}
                    </div>
                </ul>
            </li>
        </ul>
    );

    function renderLink(invoice: PartnerInvoiceDto) {
        const amount = strings._utils.formatPrice({
            amount: invoice.amount,
            currency: invoice.currency_code,
        });
        const status = strings.accountingStatus[invoice.accounting_status];
        const statusStr = status ? `, ${status}` : '';
        return (
            <Link
                to={`${API_SHORT}/v1/invoice/${invoice.invoice_number}/pdf?downloadToken=${invoice.download_token}`}
                target={'_blank'}
                key={invoice.invoice_number}
            >
                <li>
                    {strings.names[invoice.type]}
                    {statusStr}: {amount}{' '}
                    <FontAwesomeIcon icon={faDownload} className="color-blue" />
                </li>
            </Link>
        );
    }
}

function sortInvoicesIntoGroups(
    input: PartnerInvoiceDto[]
): PartnerInvoiceDto[] {
    return input.toSorted((a, b) =>
        b.invoice_number.localeCompare(a.invoice_number)
    );
}

export default PartnerInvoicesGroup;
